// src/services/configurationHistoryService.ts

import axiosInstance from "./axiosInstance";

export const getConfigurationHistory = async () => {
  try {
    const response = await axiosInstance.get("/GetConfigurationhistory");
    return response.data;
  } catch (error) {
    console.error("Failed to fetch configuration history", error);
    throw error;
  }
};
